import { render, staticRenderFns } from "./waiting_on_customer_report.vue?vue&type=template&id=251ea079&scoped=true&"
import script from "./waiting_on_customer_report.vue?vue&type=script&lang=js&"
export * from "./waiting_on_customer_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ea079",
  null
  
)

export default component.exports